var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRight = function SvgRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 0.999349C17.3335 0.539112 16.9604 0.166016 16.5001 0.166016C16.0399 0.166016 15.6668 0.539112 15.6668 0.999349V10.9993C15.6668 11.4595 16.0399 11.8326 16.5001 11.8326C16.9604 11.8326 17.3335 11.4595 17.3335 10.9993V0.999349Z",
    fill: "#777776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33348 2.66636C2.33348 1.83302 2.33348 1.83302 3.16681 1.83302C4.00014 1.83302 10.8293 1.83302 11.5001 1.83302C12.3335 1.83302 12.3335 1.83302 12.3335 2.66636C12.3335 3.49969 12.3335 9.33262 12.3335 9.33262C12.3335 10.166 12.3335 10.166 11.5001 10.1664C11.5001 10.1664 4.00014 10.1665 3.16681 10.1664C2.33348 10.1664 2.33348 10.1664 2.33348 9.33302C2.33348 8.49969 2.33348 3.30288 2.33348 2.66636ZM12.3335 0.166357C13.254 0.166357 14.0001 0.912549 14.0001 1.83302V10.1664C14.0001 11.0869 13.254 11.8331 12.3335 11.8331L2.33348 11.8331C1.413 11.8331 0.666809 11.0869 0.666809 10.1664V1.83302C0.666809 0.912548 1.413 0.166356 2.33348 0.166356L12.3335 0.166357Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right.69d61706.svg";
export { ForwardRef as ReactComponent };